<template>
  <div v-if="menu">
    <DefaultTemplate ref="DefaultTemplate" :display-mode="device">
      <template v-if="showSideBar" #sidebar>
        <Sidebar
          ref="sidebar"
          :menu="menu"
          :logo="isXmasEnabled ? 'logo' : 'logo'"
          :display-mode="device"
          :profile="profile"
          @toggleMenu="toggleMenu"
          @openMenu="openMenu"
        >
          <template #profile>
            <Profile
              v-if="profile"
              :avatar-src="profile.avatar_link"
              :text="profile.first_name"
              :subtext="profile.phone"
              :display-mode="device"
              @openMenu="openMenu"
            />
          </template>
        </Sidebar>
      </template>
      <template #header>

        <div v-if="redirected" class="special-noty">
          <p class="special-noty__text">
            <strong>{{ $t('latest_cabinet') }}</strong>
            {{ $t('go_to_old_version') }}
          </p>
          <a class="special-noty__link" href="https://bbo.briskly.online/?redirected">{{ $t('common.proceed') }}</a>
        </div>

        <Header :display-mode="device" @menuClickHadnler="headerMenuClickHandler" />
      </template>
      <template #content>
        <div v-if="serviceNotifications.status !== 'ok'" v-html="serviceNotifications.message" class="service-notifications"/>
        <Notifications v-if="$route.name !== 'carts$carts'" />
        <NotificationsOnlineCarts v-else />

        <router-view class="router-view" />

        <div class="helper-icons" :class="isTablet ? 'tablet' : ''">
          <div>
            <Icon name="icon_help" class="help-icon" @click="openFAQ" />
          </div>
          <div v-if="!revealChat && isSupportChatEnabled">
            <Icon name="icon_chat" class="chat-icon" @click="openSupportChat" />
            <div v-if="unreadMessagesCount" class="chat-icon__counter">{{ unreadMessagesCount }}</div>
          </div>
        </div>

        <SideModal
          v-if="isFAQDisplayed"
          :show-buttons="false"
          :title="$t('faq')"
          class="chat-sidemodal"
          :class="{ '_isMobile': isMobile }"
          @onClose="isFAQDisplayed = false"
        >
          <FAQ />
        </SideModal>

        <SideModal
          v-if="revealChat"
          :show-buttons="false"
          :title="$t('support_service')"
          class="chat-sidemodal"
          :class="{ '_isMobile': isMobile }"
          @onClose="onCloseSupportChat"
        >
          <Chat :float-position="isMobile ? 'fixed' : 'absolute'" />
        </SideModal>
      </template>
      <template #footer>
        <Footer />
      </template>
    </DefaultTemplate>
  </div>
  <!--  <Snowflakes v-if="isXmasEnabled && snowflakesEnabled" />-->
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { DatePicker } from 'v-calendar';
import { Icon, SideModal, BaseInput } from '@brskl/ui-lib';
import { bus } from '@brskl/core';
import { companyAPI } from '@/core/api/company.js';
import DefaultTemplate from '@/core/components/organism/DefaultTemplate/DefaultTemplate.vue';
import Notifications from '@/core/components/organism/Notifications/Notifications';
import NotificationsOnlineCarts from '@/core/components/organism/OnlineCartNotifications/Notifications.vue';
import Sidebar from '@/core/components/organism/Sidebar/Sidebar.vue';
import Profile from '@/core/components/organism/Profile/Profile.vue';
import Header from '@/core/components/layouts/Header/Header.vue';
import Footer from '@/core/components/layouts/Footer/Footer.vue';
import Chat from '@/core/components/Chat/Chat.vue';
import FAQ from '@/core/components/FAQ/FAQ.vue';
import Snowflakes from '@/core/views/Snowflakes';

const isCookieSet = () => {
  try {
    return document.cookie
      .split(';')
      .map((i) => i.trim())
      .includes('redirected=1');
  } catch (e) {
    console.error(e);
    return false;
  }
};

export default {
  components: {
    Sidebar,
    Header,
    Footer,
    Profile,
    DefaultTemplate,
    Notifications,
    NotificationsOnlineCarts,
    Icon,
    Chat,
    FAQ,
    SideModal,
    BaseInput,
    Snowflakes,
    DatePicker,
  },
  data() {
    return {
      redirected: false,
      device: 'mobile',
      revealChat: false,
      messages: {},
      isFAQDisplayed: false,
      unreadMessagesCount: 0,
    };
  },
  computed: {
    ...mapGetters({
      deviceIs: 'core$browser/deviceIs',
      menu: 'core$menu/menu',
      profile: 'shared$profile/profile',
      isReady: 'core$main/isReady',
      isTv: 'core$main/isTv',
      isSupportChatEnabled: 'core$main/isSupportChatEnabled',
      isXmasEnabled: 'core$main/isXmasEnabled',
      page_size: 'core$employeePreferences/pageSize',
      snowflakesEnabled: 'core$employeePreferences/isXmasEnabled',
      isMobileTableFooterOpened: 'mobileFooterStore$mobileFooterStore/isFooterOpened',
      shouldOpenChat: 'core$notifications/shouldOpenChat',
      serviceNotifications: 'core$main/serviceNotifications'
    }),
    isMobile() {
      return this.deviceIs === 'mobile';
    },
    isTablet() {
      return this.deviceIs === 'tablet';
    },
    isMapOpened() {
      return this.$route.name === 'tradepoints$list/map';
    },
    showSideBar() {
      return this.isReady;
    },
  },
  watch: {
    deviceIs(device) {
      this.device = device;
    },
    shouldOpenChat(newVal) {
      console.log(newVal);
      if (newVal === true) {
        this.setChat(false);
        this.openSupportChat();
      }
    },
  },
  mounted() {
    this.setUserBrowser();
    window.addEventListener('resize', this.setWindowSize);
    this.setWindowSize();
    this.initializeChat();
    this.getServiceNotifications();
    this.$watch(
      () => this.$route,
      (value) => {
        const excludedRoutes = ['auth', 'auth2', 'logout'];
        if (this.$route.query.isTV === 'true') {
          this.setTvMode(true);
          console.log('success');
          excludedRoutes.push('carts$carts');
        } else {
          this.setTvMode(false);
        }
        const catched = excludedRoutes.find((route) => route === value.name);

        this.$refs.DefaultTemplate.toggleLayouts(catched);
      },
      { immediate: true },
    );
  },
  unmounted() {
    bus.off('core$chat/newChatMessage', this.onChatMessage);
  },
  async created() {
    try {
      const isRedirected = location.search.indexOf('?redirected') !== -1 || isCookieSet();
      if (isRedirected) {
        this.redirected = true;
        if (!isCookieSet()) {
          document.cookie = `redirected=1; max-age=${60 * 60 * 24 * 7}`;
        }
      } else {
        document.cookie = 'redirected=0; max-age=0';
      }
      const { preferences } = await companyAPI.getEmployeePreferences();
      await this.setEmployeePreferences({ key: 'page_size', preferences: preferences.page_size });
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    ...mapMutations({
      setWindowSize: 'core$browser/setWindowSize',
      setUserBrowser: 'core$browser/setUserBrowser',
    }),

    ...mapActions({
      globalInit: 'core$main/globalInit',
      setTvMode: 'core$main/setTvMode',
      setPageSize: 'core$employeePreferences/setPageSize',
      setEmployeePreferences: 'core$employeePreferences/setEmployeePreferences',
      add: 'core$notifications/add',
      setChat: 'core$notifications/setChat',
      getServiceNotifications: 'core$main/getServiceNotifications',
    }),

    openMenu() {
      switch (this.device) {
        case 'desktop-tablet':
          return (this.device = 'desktop');
        default:
      }
    },

    toggleMenu() {
      switch (this.device) {
        case 'desktop':
          return (this.device = 'desktop-tablet');
        case 'desktop-tablet':
          return (this.device = 'desktop');
        case 'tablet':
        case 'mobile':
          return this.headerMenuClickHandler();
        default:
      }
    },

    headerMenuClickHandler() {
      this.$refs.sidebar.toggleForceCollapse();
    },

    openFAQ() {
      this.isFAQDisplayed = true;
    },

    async openSupportChat() {
      this.revealChat = true;
      this.unreadMessagesCount = 0;
    },

    onCloseSupportChat() {
      this.revealChat = false;
    },

    async fetchMessages() {
      try {
        const { items } = await companyAPI.getMessages({
          limit: 9999,
          page: 1,
        });
        this.messages = items.map((item) => ({
          ...item,
          created_at: item.created_at.split(' ').join('T'),
        }));
      } catch (error) {
        console.error(error);
      }
    },

    handleNewMessageNotification(message) {
      if (!message?.id) return;
      if (message.is_read) return;
      if (message.sender.alias !== 'administrator') return;
      this.unreadMessagesCount += 1;
      this.add({
        message: message.text,
        value: message,
        type: 'chat-message',
        source: 'handleChatMessage',
        title: this.$t('new_message'),
      });
    },

    onChatMessage(data) {
      this.handleNewMessageNotification(data?.chat_message);
    },

    async initializeChat() {
      await this.fetchMessages();
      bus.on('core$chat/newChatMessage', this.onChatMessage);
      this.messages.forEach((message) => this.handleNewMessageNotification(message));
    },

    async sendNewChatMessage(text) {
      if (text.trim() === '') return;
      await companyAPI.sendMessage({ text });
    },
  },
};
</script>

<style lang="scss" scoped src="./Mainbubp.scss"></style>
<style lang="scss">
.service-notifications {
  padding: 16px;
  margin-top: 16px;
  border: 1px solid red;
  border-radius: 12px;

  p {
    color: red;
    font-size: 14px;
    line-height: 20px;
  }
}
</style>

<i18n>
{
  "ru": {
    "latest_cabinet": "Вы находитесь в последней версии личного кабинета.",
    "go_to_old_version": "Перейти к старой версии?",
    "faq": "Частые вопросы",
    "support_service": "Служба поддержки",
    "new_message": "Новое сообщение"
  },
  "en": {
    "latest_cabinet": "You are in the latest version of the personal account.",
    "go_to_old_version": "Go to the previous version?",
    "faq": "FAQ",
    "support_service": "Support service",
    "new_message": "New message"
  }
}
</i18n>
